export default "__VITE_ASSET__CpFvXJoN__"